import { VideoBlockFragment } from 'src/strapi/queries'
import { CtaModel } from '../types/ctaModel'
import { normalizeCtaFromStrapi } from '../hooks/normalizeCtaFromStrapi'

export type NormalizedVideo = {
  ready: boolean
  title: string
  description: string
  isComponentRight: boolean
  iframeSrc: string
  thumbnailUrl: string
  cta: CtaModel | null
}

export function normalizeVideo(
  block?: VideoBlockFragment | null,
): NormalizedVideo | null {
  const item = block?.videoBlock?.find(Boolean)
  if (!item) return null
  const iframeSrc = item.video?.iframeSrc ?? ''
  const thumbnailUrl = item.video?.thumbnailUrl?.url ?? ''
  return {
    ready: !!iframeSrc,
    title: item.title ?? '',
    description: item.description ?? '',
    isComponentRight: item.isComponentRight ?? false,
    iframeSrc,
    thumbnailUrl,
    cta: normalizeCtaFromStrapi(item.primaryAction),
  }
}
